import { render } from "./AnalyticsFunnels.vue?vue&type=template&id=b870ff1c"
import script from "./AnalyticsFunnels.vue?vue&type=script&lang=js"
export * from "./AnalyticsFunnels.vue?vue&type=script&lang=js"

import "./AnalyticsFunnels.vue?vue&type=style&index=0&id=b870ff1c&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__